import { activeIndex } from './index';

let defaultValue = [];

function setValue(value) {
  defaultValue[activeIndex.getValue()] = value;
}

function setValueWithIndex(value, index) {
  defaultValue[index] = value;
}

function getValue() {
  return defaultValue[activeIndex.getValue()];
}

const numberOfAnnotations = {
  setValue,
  setValueWithIndex,
  getValue,
};

export default numberOfAnnotations;
